import { Form } from '@/components/ui/form/form.component';
import { pretailoringPageMessages } from '../pre-tailoring.messages';

import { T } from '@/components/i18n/message.i18n.component';

import { NoResults } from '@/components/elements/no-results/no-results.component';
import { QuestionInput } from '@/components/elements/question-input/question-input.component';
import { YesNoQuestion } from '@/gql/graphql';

import { cn } from '@/lib/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { generateInitialValues } from './questions.component.utils';

type Props = {
  disabled: boolean;
  handleSubmit: () => void;
  radioQuestions: YesNoQuestion[];
  handleQuestionAnswer: (question: YesNoQuestion, answer: string) => void;
};

export const Questions = ({
  disabled,
  radioQuestions,
  handleQuestionAnswer: onQuestionAnswer,
  handleSubmit,
}: Props) => {
  const generateSchema = useCallback((questions: YesNoQuestion[]) => {
    const zodObject = Object.fromEntries(
      questions.map((question) => {
        return [question.id, z.string()];
      }),
    );
    return z.object(zodObject);
  }, []);

  const form = useForm<z.infer<ReturnType<typeof generateSchema>>>({
    resolver: zodResolver(generateSchema(radioQuestions)),
    values: generateInitialValues(radioQuestions),
  });

  const onSubmit = async () => {
    handleSubmit();
  };

  return (
    <div className={cn(radioQuestions.length === 0 && 'flex h-full')}>
      {radioQuestions.length === 0 && (
        <NoResults
          data-testid="questions-no-questions"
          className="mb-0"
          message={<T {...pretailoringPageMessages.questionsNoQuestions} />}
        />
      )}
      <Form {...form}>
        <form
          data-testid="pre-tailoring-questions-form"
          id="hook-form"
          onSubmit={form.handleSubmit(onSubmit)}
          className="active:border-none gap-y-6 flex flex-col"
        >
          {radioQuestions.map((question, index) => (
            <QuestionInput
              index={index}
              key={question.id}
              question={question}
              formControl={form.control}
              disabled={disabled}
              handleQuestionAnswer={onQuestionAnswer}
            />
          ))}
        </form>
      </Form>
    </div>
  );
};
